export default "__VITE_ASSET__B4vaaPv9__"